var map = {
	"./fonts/Averta-Black.otf": 2936,
	"./fonts/Averta-BlackItalic.otf": 291,
	"./fonts/Averta-Bold.otf": 1152,
	"./fonts/Averta-BoldItalic.otf": 5734,
	"./fonts/Averta-ExtraBold.otf": 7415,
	"./fonts/Averta-ExtraBoldItalic.otf": 7342,
	"./fonts/Averta-Extrathin.otf": 6800,
	"./fonts/Averta-ExtrathinItalic.otf": 4952,
	"./fonts/Averta-Light.otf": 6424,
	"./fonts/Averta-LightItalic.otf": 2603,
	"./fonts/Averta-Regular.otf": 544,
	"./fonts/Averta-RegularItalic.otf": 9720,
	"./fonts/Averta-Semibold.otf": 2538,
	"./fonts/Averta-SemiboldItalic.otf": 2411,
	"./fonts/Averta-Thin.otf": 1432,
	"./fonts/Averta-ThinItalic.otf": 6978,
	"./icons/Vector.svg": 1216,
	"./icons/account.svg": 3647,
	"./icons/add-new.svg": 7242,
	"./icons/angle-down.svg": 7454,
	"./icons/arrow-down.svg": 4746,
	"./icons/arrow-right.svg": 153,
	"./icons/arrow-up.svg": 9689,
	"./icons/audio.svg": 2394,
	"./icons/back.svg": 7911,
	"./icons/bookmark.svg": 8619,
	"./icons/button-back.svg": 8876,
	"./icons/cancel.svg": 7373,
	"./icons/easy.svg": 2247,
	"./icons/exclamation.svg": 5978,
	"./icons/hard.svg": 2737,
	"./icons/iconmoi.svg": 5590,
	"./icons/logout-mobile.svg": 5903,
	"./icons/logout.svg": 2990,
	"./icons/magnifier.svg": 372,
	"./icons/menu.svg": 5674,
	"./icons/normal.svg": 2440,
	"./icons/openbook.svg": 3290,
	"./icons/password.svg": 5386,
	"./icons/pencil.svg": 1265,
	"./icons/plus.svg": 3189,
	"./icons/reload.svg": 6939,
	"./icons/save.svg": 3884,
	"./icons/trash.svg": 967,
	"./icons/white-plus.svg": 4492,
	"./images/final.png": 4725,
	"./images/firework-bg.svg": 1197,
	"./images/firework.svg": 9014,
	"./images/logo.svg": 2835,
	"./images/miniLogo.png": 7285,
	"./images/success.svg": 1185,
	"./images/volumn.svg": 3143,
	"./styles/style.sass": 3247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;